import { render, staticRenderFns } from "./JobRequirements.vue?vue&type=template&id=f0e4ed92&"
import script from "./JobRequirements.vue?vue&type=script&lang=js&"
export * from "./JobRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports